'use client';

import { useEffect } from 'react';
import { CidAtmosphere } from '@/components/common/CidAtmosphere';
import { Footer } from '@/components/common/Footer';
import { Header } from '@/components/common/Header';
import { SkipLink } from '@/components/common/SkipLink';
import { Button } from '@/components/ui/Button';
import { ROUTES } from '@/lib/constants';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('App error:', error);
  }, [error]);

  return (
    <div className="cid-site" style={{ display: 'flex', flexDirection: 'column' }}>
      <SkipLink target="main-content" />
      <CidAtmosphere mode="viewport" />
      <Header />
      <div
        className="cid-container"
        style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '48px var(--cid-gutter, 32px)' }}
      >
        <main id="main-content" style={{ width: '100%' }}>
          <section
            className="cid-panel"
            style={{ maxWidth: '680px', margin: '0 auto', padding: '40px 32px', borderRadius: '20px' }}
          >
            <p className="cid-eyebrow">APPLICATION ERROR</p>
            <h1 style={{ margin: '0 0 14px', fontSize: 'clamp(32px, 4vw, 46px)', lineHeight: 1.15 }}>
              Something went wrong.
            </h1>
            <p className="cid-intro">
              An unexpected error occurred while loading this page. Please try again or return to
              the homepage.
            </p>
            <div className="cid-hero-actions">
              <Button onClick={reset}>Try Again</Button>
              <Button href={ROUTES.home} variant="secondary">
                Back to Home
              </Button>
            </div>
          </section>
        </main>
      </div>
      <Footer />
    </div>
  );
}
